import { render } from "./topNavBar.vue?vue&type=template&id=edbefae6&scoped=true"
import script from "./topNavBar.vue?vue&type=script&lang=js"
export * from "./topNavBar.vue?vue&type=script&lang=js"

import "./topNavBar.vue?vue&type=style&index=0&id=edbefae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbefae6"]])

export default __exports__